var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",staticStyle:{"display":"block","margin":"0 auto"},attrs:{"type":"button","disabled":_vm.order.ret_points === true,"title":_vm.order.ret_points ? 'Order is refunded' : ''},on:{"click":_vm.submit}},[_vm._v(" Refund Order ")])
}
var staticRenderFns = []

export { render, staticRenderFns }